import { render, staticRenderFns } from "./events-list-item.vue?vue&type=template&id=37d2c11e&"
import script from "./events-list-item.vue?vue&type=script&lang=js&"
export * from "./events-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/events/components/events-list/events-list-item.vue
// module id = 946
// module chunks = 0